/**
 * Enum representing whether an image is blurry or sharp.
 */
export enum Blurriness {
  Blurry = 'blurry',
  Sharp = 'sharp',
}
